import { FormElement } from './form-element.model';
import { NameValueInteger, NameValueString, NameValue } from '../../../shared/index';

export class FormElementDropDownStringValue extends FormElement {
  public constructor() {
    super();
    this.intialize();
  }

  public intialize = (): void => {
    this.Value = '';
    this.Items = new Array<NameValueInteger>();
    this.ProposedItemName = '';
    this.ProposedItemValue = '';
    this.SelectedValue = '';
    this.ElementTypeId = 3;
  };

  public Value: string;
  public Items: Array<NameValueInteger>;
  public ProposedItemName: string;
  public ProposedItemValue: string;
  public SelectedValue: string;
}
